import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesNotificationsMain } from './modules/ui/Main';

const NotificationsPage = (
  <SuspensePage>
    <PagesNotificationsMain />
  </SuspensePage>
);

export default NotificationsPage;
